import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./Login";
import Escritorio from "./Escritorio";
import Ambitos from "./Ambitos";
import Anexos from "./Anexos";
import Categorias from "./Categorias";
import Documentos from "./Documentos";
import Expediente from "./Expediente";
import F1s from "./formatos/F1s";
import F2s from "./formatos/F2s";
import F2as from "./formatos/F2as";
import F3s from "./formatos/F3s";
import F4s from "./formatos/F4s";
import F4as from "./formatos/F4as";
import F5s from "./formatos/F5s";
import F5as from "./formatos/F5as";
import F5bs from "./formatos/F5bs";
import F6s from "./formatos/F6s";
import F6as from "./formatos/F6as";
import F6bs from "./formatos/F6bs";
import F7s from "./formatos/F7s";
import F8s from "./formatos/F8s";
import F9s from "./formatos/F9s";
import F9as from "./formatos/F9as";
import F10s from "./formatos/F10s";
import F10as from "./formatos/F10as";
import F11s from "./formatos/F11s";
import F12s from "./formatos/F12s";
import F12as from "./formatos/F12as";
import F12bs from "./formatos/F12bs";
import F12cs from "./formatos/F12cs";
import F13s from "./formatos/F13s";
import F13as from "./formatos/F13as";
import F13bs from "./formatos/F13bs";
import F13cs from "./formatos/F13cs";
import F14s from "./formatos/F14s";
import F14as from "./formatos/F14as";
import F15s from "./formatos/F15s";
import F16s from "./formatos/F16s";
import F17s from "./formatos/F17s";
import F17as from "./formatos/F17as";
import F18s from "./formatos/F18s";
import F19s from "./formatos/F19s";
import F20s from "./formatos/F20s";
import F21s from "./formatos/F21s";
import F22s from "./formatos/F22s";
import F23s from "./formatos/F23s";
import F24s from "./formatos/F24s";
import F24as from "./formatos/F24as";
import F25s from "./formatos/F25s";
import F26s from "./formatos/F26s";
import F26as from "./formatos/F26as";
import F26bs from "./formatos/F26bs";
import F27s from "./formatos/F27s";
import F28s from "./formatos/F28s";
import F29s from "./formatos/F29s";
import F30s from "./formatos/F30s";
import F31s from "./formatos/F31s";
import F32s from "./formatos/F32s";
import F33s from "./formatos/F33s";
import F34s from "./formatos/F34s";
import F35s from "./formatos/F35s";
import F36s from "./formatos/F36s";
import F37s from "./formatos/F37s";
import F38s from "./formatos/F38s";
import F39s from "./formatos/F39s";
import F40s from "./formatos/F40s";
import F41s from "./formatos/F41s";
import F42s from "./formatos/F42s";
import F42as from "./formatos/F42as";
import F43s from "./formatos/F43s";
import F44s from "./formatos/F44s";
import F45s from "./formatos/F45s";
import F46s from "./formatos/F46s";
import F47s from "./formatos/F47s";
import F48s from "./formatos/F48s";
import F49s from "./formatos/F49s";
import F50s from "./formatos/F50s";
import F51s from "./formatos/F51s";
import F52s from "./formatos/F52s";
import F52as from "./formatos/F52as";
import F52bs from "./formatos/F52bs";
import F53s from "./formatos/F53s";
import F53as from "./formatos/F53as";
import F53bs from "./formatos/F53bs";
import F53cs from "./formatos/F53cs";
import F53ds from "./formatos/F53ds";
import F53es from "./formatos/F53es";
import F53fs from "./formatos/F53fs";
import F53gs from "./formatos/F53gs";
import F53hs from "./formatos/F53hs";
import F53is from "./formatos/F53is";
import F53js from "./formatos/F53js";
import F53ks from "./formatos/F53ks";
import F53ls from "./formatos/F53ls";
import F53ms from "./formatos/F53ms";
import F53ns from "./formatos/F53ns";
import F53os from "./formatos/F53os";
import F54s from "./formatos/F54s";
import F55s from "./formatos/F55s";
import F56s from "./formatos/F56s";
import F57s from "./formatos/F57s";
import F58s from "./formatos/F58s";
import F59s from "./formatos/F59s";
import F60s from "./formatos/F60s";
import F61s from "./formatos/F61s";
import F62s from "./formatos/F62s";
import F63s from "./formatos/F63s";
import F64s from "./formatos/F64s";
import F65s from "./formatos/F65s";
import F66s from "./formatos/F66s";
import F67s from "./formatos/F67s";
import F68s from "./formatos/F68s";
import F69s from "./formatos/F69s";
import F70s from "./formatos/F70s";
import F71s from "./formatos/F71s";
import F72s from "./formatos/F72s";
import F73s from "./formatos/F73s";
import F74s from "./formatos/F74s";
import F75s from "./formatos/F75s";
import F76s from "./formatos/F76s";
import F77s from "./formatos/F77s";
import F78s from "./formatos/F78s";
import F79s from "./formatos/F79s";
import F80s from "./formatos/F80s";
import F81s from "./formatos/F81s";
import F82s from "./formatos/F82s";
import F83s from "./formatos/F83s";
import F84s from "./formatos/F84s";
import F85s from "./formatos/F85s";
import F86s from "./formatos/F86s";
import F87s from "./formatos/F87s";
import F88s from "./formatos/F88s";
import F89s from "./formatos/F89s";
import F90s from "./formatos/F90s";
import F91s from "./formatos/F91s";
import F91as from "./formatos/F91as";
import F91bs from "./formatos/F91bs";
import F92s from "./formatos/F92s";
import F92as from "./formatos/F92as";
import F92bs from "./formatos/F92bs";
import F92cs from "./formatos/F92cs";
import F92ds from "./formatos/F92ds";
import F92es from "./formatos/F92es";
import F92fs from "./formatos/F92fs";
import F92gs from "./formatos/F92gs";
import F92hs from "./formatos/F92hs";
import F92is from "./formatos/F92is";
import F92js from "./formatos/F92js";
import F93s from "./formatos/F93s";
import F94s from "./formatos/F94s";
import F95s from "./formatos/F95s";
import F95as from "./formatos/F95as";
import F96s from "./formatos/F96s";
import F97s from "./formatos/F97s";
import F98s from "./formatos/F98s";

import D76s from "./digital/F76s";

import Historiales from "./Historiales";
import Usuarios from "./Usuarios";

import CargaQR from "./CargaQR";

import Logout from "./Logout";
import NoPermitido from "./NoPermitido";
import Formatos from "./Formatos";
import Organigramas from "./Organigramas";

import "./estilos.css";
import MensajesAll from "./formatos/MensajesAll";

class App extends Component {
  render() {
    return (
      <BrowserRouter basename={'/'}>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/escritorio" component={Escritorio} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/ambitos" component={Ambitos} />
          <Route exact path="/anexos" component={Anexos} />
          <Route exact path="/categorias" component={Categorias} />
          <Route exact path="/documentos" component={Documentos} />
          <Route exact path="/denegado" component={NoPermitido} />
          <Route exact path="/formatos" component={Formatos} />
          <Route exact path="/organigramas/:ambito_id" component={Organigramas} />
          <Route exact path="/mensajes" component={MensajesAll} />
          <Route exact path="/expediente/:uuid" component={Expediente} />
          {/*
          <Route
            exact
            path="/CargaQR/:ambito_id/:formato_cve/:id_registro"
            component={CargaQR}
          />
          */}
          <Route exact path="/CargaQR/:uuid" component={CargaQR} />

          <Route exact path="/f1s" component={F1s} />
          <Route exact path="/f1s/ambito/:ambito_id" component={F1s} />

          <Route exact path="/f2s" component={F2s} />
          <Route exact path="/f2s/ambito/:ambito_id" component={F2s} />

          <Route exact path="/f2as" component={F2as} />
          <Route exact path="/f2as/ambito/:ambito_id" component={F2as} />

          <Route exact path="/f3s" component={F3s} />
          <Route exact path="/f3s/ambito/:ambito_id" component={F3s} />

          <Route exact path="/f4s" component={F4s} />
          <Route exact path="/f4s/ambito/:ambito_id" component={F4s} />

          <Route exact path="/f4as" component={F4as} />
          <Route exact path="/f4as/ambito/:ambito_id" component={F4as} />

          <Route exact path="/f5s" component={F5s} />
          <Route exact path="/f5s/ambito/:ambito_id" component={F5s} />

          <Route exact path="/f5as" component={F5as} />
          <Route exact path="/f5as/ambito/:ambito_id" component={F5as} />

          <Route exact path="/f5bs" component={F5bs} />
          <Route exact path="/f5bs/ambito/:ambito_id" component={F5bs} />

          <Route exact path="/f6s" component={F6s} />
          <Route exact path="/f6s/ambito/:ambito_id" component={F6s} />

          <Route exact path="/f6as" component={F6as} />
          <Route exact path="/f6as/ambito/:ambito_id" component={F6as} />

          <Route exact path="/f6bs" component={F6bs} />
          <Route exact path="/f6bs/ambito/:ambito_id" component={F6bs} />

          <Route exact path="/f7s" component={F7s} />
          <Route exact path="/f7s/ambito/:ambito_id" component={F7s} />

          <Route exact path="/f8s" component={F8s} />
          <Route exact path="/f8s/ambito/:ambito_id" component={F8s} />

          <Route exact path="/f9s" component={F9s} />
          <Route exact path="/f9s/ambito/:ambito_id" component={F9s} />

          <Route exact path="/f9as" component={F9as} />
          <Route exact path="/f9as/ambito/:ambito_id" component={F9as} />

          <Route exact path="/f10s" component={F10s} />
          <Route exact path="/f10s/ambito/:ambito_id" component={F10s} />

          <Route exact path="/f10as" component={F10as} />
          <Route exact path="/f10as/ambito/:ambito_id" component={F10as} />

          <Route exact path="/f11s" component={F11s} />
          <Route exact path="/f11s/ambito/:ambito_id" component={F11s} />

          <Route exact path="/f12s" component={F12s} />
          <Route exact path="/f12s/ambito/:ambito_id" component={F12s} />

          <Route exact path="/f12as" component={F12as} />
          <Route exact path="/f12as/ambito/:ambito_id" component={F12as} />

          <Route exact path="/f12bs" component={F12bs} />
          <Route exact path="/f12bs/ambito/:ambito_id" component={F12bs} />

          <Route exact path="/f12cs" component={F12cs} />
          <Route exact path="/f12cs/ambito/:ambito_id" component={F12cs} />

          <Route exact path="/f13s" component={F13s} />
          <Route exact path="/f13s/ambito/:ambito_id" component={F13s} />

          <Route exact path="/f13as" component={F13as} />
          <Route exact path="/f13as/ambito/:ambito_id" component={F13as} />

          <Route exact path="/f13bs" component={F13bs} />
          <Route exact path="/f13bs/ambito/:ambito_id" component={F13bs} />

          <Route exact path="/f13cs" component={F13cs} />
          <Route exact path="/f13cs/ambito/:ambito_id" component={F13cs} />

          <Route exact path="/f14s" component={F14s} />
          <Route exact path="/f14s/ambito/:ambito_id" component={F14s} />

          <Route exact path="/f14as" component={F14as} />
          <Route exact path="/f14as/ambito/:ambito_id" component={F14as} />

          <Route exact path="/f15s" component={F15s} />
          <Route exact path="/f15s/ambito/:ambito_id" component={F15s} />

          <Route exact path="/f16s" component={F16s} />
          <Route exact path="/f16s/ambito/:ambito_id" component={F16s} />

          <Route exact path="/f17s" component={F17s} />
          <Route exact path="/f17s/ambito/:ambito_id" component={F17s} />

          <Route exact path="/f17as" component={F17as} />
          <Route exact path="/f17as/ambito/:ambito_id" component={F17as} />

          <Route exact path="/f18s" component={F18s} />
          <Route exact path="/f18s/ambito/:ambito_id" component={F18s} />

          <Route exact path="/f19s" component={F19s} />
          <Route exact path="/f19s/ambito/:ambito_id" component={F19s} />

          <Route exact path="/f20s" component={F20s} />
          <Route exact path="/f20s/ambito/:ambito_id" component={F20s} />

          <Route exact path="/f21s" component={F21s} />
          <Route exact path="/f21s/ambito/:ambito_id" component={F21s} />

          <Route exact path="/f22s" component={F22s} />
          <Route exact path="/f22s/ambito/:ambito_id" component={F22s} />

          <Route exact path="/f23s" component={F23s} />
          <Route exact path="/f23s/ambito/:ambito_id" component={F23s} />

          <Route exact path="/f24s" component={F24s} />
          <Route exact path="/f24s/ambito/:ambito_id" component={F24s} />

          <Route exact path="/f24as" component={F24as} />
          <Route exact path="/f24as/ambito/:ambito_id" component={F24as} />

          <Route exact path="/f25s" component={F25s} />
          <Route exact path="/f25s/ambito/:ambito_id" component={F25s} />

          <Route exact path="/f26s" component={F26s} />
          <Route exact path="/f26s/ambito/:ambito_id" component={F26s} />

          <Route exact path="/f26as" component={F26as} />
          <Route exact path="/f26as/ambito/:ambito_id" component={F26as} />

          <Route exact path="/f26bs" component={F26bs} />
          <Route exact path="/f26bs/ambito/:ambito_id" component={F26bs} />

          <Route exact path="/f27s" component={F27s} />
          <Route exact path="/f27s/ambito/:ambito_id" component={F27s} />

          <Route exact path="/f28s" component={F28s} />
          <Route exact path="/f28s/ambito/:ambito_id" component={F28s} />

          <Route exact path="/f29s" component={F29s} />
          <Route exact path="/f29s/ambito/:ambito_id" component={F29s} />

          <Route exact path="/f30s" component={F30s} />
          <Route exact path="/f30s/ambito/:ambito_id" component={F30s} />

          <Route exact path="/f31s" component={F31s} />
          <Route exact path="/f31s/ambito/:ambito_id" component={F31s} />

          <Route exact path="/f32s" component={F32s} />
          <Route exact path="/f32s/ambito/:ambito_id" component={F32s} />

          <Route exact path="/f33s" component={F33s} />
          <Route exact path="/f33s/ambito/:ambito_id" component={F33s} />

          <Route exact path="/f34s" component={F34s} />
          <Route exact path="/f34s/ambito/:ambito_id" component={F34s} />

          <Route exact path="/f35s" component={F35s} />
          <Route exact path="/f35s/ambito/:ambito_id" component={F35s} />

          <Route exact path="/f36s" component={F36s} />
          <Route exact path="/f36s/ambito/:ambito_id" component={F36s} />

          <Route exact path="/f37s" component={F37s} />
          <Route exact path="/f37s/ambito/:ambito_id" component={F37s} />

          <Route exact path="/f38s" component={F38s} />
          <Route exact path="/f38s/ambito/:ambito_id" component={F38s} />

          <Route exact path="/f39s" component={F39s} />
          <Route exact path="/f39s/ambito/:ambito_id" component={F39s} />

          <Route exact path="/f40s" component={F40s} />
          <Route exact path="/f40s/ambito/:ambito_id" component={F40s} />

          <Route exact path="/f41s" component={F41s} />
          <Route exact path="/f41s/ambito/:ambito_id" component={F41s} />

          <Route exact path="/f42s" component={F42s} />
          <Route exact path="/f42s/ambito/:ambito_id" component={F42s} />

          <Route exact path="/f42as" component={F42as} />
          <Route exact path="/f42as/ambito/:ambito_id" component={F42as} />

          <Route exact path="/f43s" component={F43s} />
          <Route exact path="/f43s/ambito/:ambito_id" component={F43s} />

          <Route exact path="/f44s" component={F44s} />
          <Route exact path="/f44s/ambito/:ambito_id" component={F44s} />

          <Route exact path="/f45s" component={F45s} />
          <Route exact path="/f45s/ambito/:ambito_id" component={F45s} />

          <Route exact path="/f46s" component={F46s} />
          <Route exact path="/f46s/ambito/:ambito_id" component={F46s} />

          <Route exact path="/f47s" component={F47s} />
          <Route exact path="/f47s/ambito/:ambito_id" component={F47s} />

          <Route exact path="/f48s" component={F48s} />
          <Route exact path="/f48s/ambito/:ambito_id" component={F48s} />

          <Route exact path="/f49s" component={F49s} />
          <Route exact path="/f49s/ambito/:ambito_id" component={F49s} />

          <Route exact path="/f50s" component={F50s} />
          <Route exact path="/f50s/ambito/:ambito_id" component={F50s} />

          <Route exact path="/f51s" component={F51s} />
          <Route exact path="/f51s/ambito/:ambito_id" component={F51s} />

          <Route exact path="/f52s" component={F52s} />
          <Route exact path="/f52s/ambito/:ambito_id" component={F52s} />

          <Route exact path="/f52as" component={F52as} />
          <Route exact path="/f52as/ambito/:ambito_id" component={F52as} />

          <Route exact path="/f52bs" component={F52bs} />
          <Route exact path="/f52bs/ambito/:ambito_id" component={F52bs} />

          <Route exact path="/f53s" component={F53s} />
          <Route exact path="/f53s/ambito/:ambito_id" component={F53s} />

          <Route exact path="/f53as" component={F53as} />
          <Route exact path="/f53as/ambito/:ambito_id" component={F53as} />

          <Route exact path="/f53bs" component={F53bs} />
          <Route exact path="/f53bs/ambito/:ambito_id" component={F53bs} />

          <Route exact path="/f53cs" component={F53cs} />
          <Route exact path="/f53cs/ambito/:ambito_id" component={F53cs} />

          <Route exact path="/f53ds" component={F53ds} />
          <Route exact path="/f53ds/ambito/:ambito_id" component={F53ds} />

          <Route exact path="/f53es" component={F53es} />
          <Route exact path="/f53es/ambito/:ambito_id" component={F53es} />

          <Route exact path="/f53fs" component={F53fs} />
          <Route exact path="/f53fs/ambito/:ambito_id" component={F53fs} />

          <Route exact path="/f53gs" component={F53gs} />
          <Route exact path="/f53gs/ambito/:ambito_id" component={F53gs} />

          <Route exact path="/f53hs" component={F53hs} />
          <Route exact path="/f53hs/ambito/:ambito_id" component={F53hs} />

          <Route exact path="/f53is" component={F53is} />
          <Route exact path="/f53is/ambito/:ambito_id" component={F53is} />

          <Route exact path="/f53js" component={F53js} />
          <Route exact path="/f53js/ambito/:ambito_id" component={F53js} />

          <Route exact path="/f53ks" component={F53ks} />
          <Route exact path="/f53ks/ambito/:ambito_id" component={F53ks} />

          <Route exact path="/f53ls" component={F53ls} />
          <Route exact path="/f53ls/ambito/:ambito_id" component={F53ls} />

          <Route exact path="/f53ms" component={F53ms} />
          <Route exact path="/f53ms/ambito/:ambito_id" component={F53ms} />

          <Route exact path="/f53ns" component={F53ns} />
          <Route exact path="/f53ns/ambito/:ambito_id" component={F53ns} />

          <Route exact path="/f53os" component={F53os} />
          <Route exact path="/f53os/ambito/:ambito_id" component={F53os} />

          <Route exact path="/f54s" component={F54s} />
          <Route exact path="/f54s/ambito/:ambito_id" component={F54s} />

          <Route exact path="/f55s" component={F55s} />
          <Route exact path="/f55s/ambito/:ambito_id" component={F55s} />

          <Route exact path="/f56s" component={F56s} />
          <Route exact path="/f56s/ambito/:ambito_id" component={F56s} />

          <Route exact path="/f57s" component={F57s} />
          <Route exact path="/f57s/ambito/:ambito_id" component={F57s} />

          <Route exact path="/f58s" component={F58s} />
          <Route exact path="/f58s/ambito/:ambito_id" component={F58s} />

          <Route exact path="/f59s" component={F59s} />
          <Route exact path="/f59s/ambito/:ambito_id" component={F59s} />

          <Route exact path="/f60s" component={F60s} />
          <Route exact path="/f60s/ambito/:ambito_id" component={F60s} />

          <Route exact path="/f61s" component={F61s} />
          <Route exact path="/f61s/ambito/:ambito_id" component={F61s} />

          <Route exact path="/f62s" component={F62s} />
          <Route exact path="/f62s/ambito/:ambito_id" component={F62s} />

          <Route exact path="/f63s" component={F63s} />
          <Route exact path="/f63s/ambito/:ambito_id" component={F63s} />

          <Route exact path="/f64s" component={F64s} />
          <Route exact path="/f64s/ambito/:ambito_id" component={F64s} />

          <Route exact path="/f65s" component={F65s} />
          <Route exact path="/f65s/ambito/:ambito_id" component={F65s} />

          <Route exact path="/f66s" component={F66s} />
          <Route exact path="/f66s/ambito/:ambito_id" component={F66s} />

          <Route exact path="/f67s" component={F67s} />
          <Route exact path="/f67s/ambito/:ambito_id" component={F67s} />

          <Route exact path="/f68s" component={F68s} />
          <Route exact path="/f68s/ambito/:ambito_id" component={F68s} />

          <Route exact path="/f69s" component={F69s} />
          <Route exact path="/f69s/ambito/:ambito_id" component={F69s} />

          <Route exact path="/f70s" component={F70s} />
          <Route exact path="/f70s/ambito/:ambito_id" component={F70s} />

          <Route exact path="/f71s" component={F71s} />
          <Route exact path="/f71s/ambito/:ambito_id" component={F71s} />

          <Route exact path="/f72s" component={F72s} />
          <Route exact path="/f72s/ambito/:ambito_id" component={F72s} />

          <Route exact path="/f73s" component={F73s} />
          <Route exact path="/f73s/ambito/:ambito_id" component={F73s} />

          <Route exact path="/f74s" component={F74s} />
          <Route exact path="/f74s/ambito/:ambito_id" component={F74s} />

          <Route exact path="/f75s" component={F75s} />
          <Route exact path="/f75s/ambito/:ambito_id" component={F75s} />

          <Route exact path="/f76s" component={F76s} />
          <Route exact path="/f76s/ambito/:ambito_id" component={F76s} />

          <Route exact path="/f77s" component={F77s} />
          <Route exact path="/f77s/ambito/:ambito_id" component={F77s} />

          <Route exact path="/f78s" component={F78s} />
          <Route exact path="/f78s/ambito/:ambito_id" component={F78s} />

          <Route exact path="/f79s" component={F79s} />
          <Route exact path="/f79s/ambito/:ambito_id" component={F79s} />

          <Route exact path="/f80s" component={F80s} />
          <Route exact path="/f80s/ambito/:ambito_id" component={F80s} />

          <Route exact path="/f81s" component={F81s} />
          <Route exact path="/f81s/ambito/:ambito_id" component={F81s} />

          <Route exact path="/f82s" component={F82s} />
          <Route exact path="/f82s/ambito/:ambito_id" component={F82s} />

          <Route exact path="/f83s" component={F83s} />
          <Route exact path="/f83s/ambito/:ambito_id" component={F83s} />

          <Route exact path="/f84s" component={F84s} />
          <Route exact path="/f84s/ambito/:ambito_id" component={F84s} />

          <Route exact path="/f85s" component={F85s} />
          <Route exact path="/f85s/ambito/:ambito_id" component={F85s} />

          <Route exact path="/f86s" component={F86s} />
          <Route exact path="/f86s/ambito/:ambito_id" component={F86s} />

          <Route exact path="/f87s" component={F87s} />
          <Route exact path="/f87s/ambito/:ambito_id" component={F87s} />

          <Route exact path="/f88s" component={F88s} />
          <Route exact path="/f88s/ambito/:ambito_id" component={F88s} />

          <Route exact path="/f89s" component={F89s} />
          <Route exact path="/f89s/ambito/:ambito_id" component={F89s} />

          <Route exact path="/f90s" component={F90s} />
          <Route exact path="/f90s/ambito/:ambito_id" component={F90s} />

          <Route exact path="/f91s" component={F91s} />
          <Route exact path="/f91s/ambito/:ambito_id" component={F91s} />

          <Route exact path="/f91as" component={F91as} />
          <Route exact path="/f91as/ambito/:ambito_id" component={F91as} />

          <Route exact path="/f91bs" component={F91bs} />
          <Route exact path="/f91bs/ambito/:ambito_id" component={F91bs} />

          <Route exact path="/f92s" component={F92s} />
          <Route exact path="/f92s/ambito/:ambito_id" component={F92s} />

          <Route exact path="/f92as" component={F92as} />
          <Route exact path="/f92as/ambito/:ambito_id" component={F92as} />

          <Route exact path="/f92bs" component={F92bs} />
          <Route exact path="/f92bs/ambito/:ambito_id" component={F92bs} />

          <Route exact path="/f92cs" component={F92cs} />
          <Route exact path="/f92cs/ambito/:ambito_id" component={F92cs} />

          <Route exact path="/f92ds" component={F92ds} />
          <Route exact path="/f92ds/ambito/:ambito_id" component={F92ds} />

          <Route exact path="/f92es" component={F92es} />
          <Route exact path="/f92es/ambito/:ambito_id" component={F92es} />

          <Route exact path="/f92fs" component={F92fs} />
          <Route exact path="/f92fs/ambito/:ambito_id" component={F92fs} />

          <Route exact path="/f92gs" component={F92gs} />
          <Route exact path="/f92gs/ambito/:ambito_id" component={F92gs} />

          <Route exact path="/f92hs" component={F92hs} />
          <Route exact path="/f92hs/ambito/:ambito_id" component={F92hs} />

          <Route exact path="/f92is" component={F92is} />
          <Route exact path="/f92is/ambito/:ambito_id" component={F92is} />

          <Route exact path="/f92js" component={F92js} />
          <Route exact path="/f92js/ambito/:ambito_id" component={F92js} />

          <Route exact path="/f93s" component={F93s} />
          <Route exact path="/f93s/ambito/:ambito_id" component={F93s} />

          <Route exact path="/f94s" component={F94s} />
          <Route exact path="/f94s/ambito/:ambito_id" component={F94s} />

          <Route exact path="/f95s" component={F95s} />
          <Route exact path="/f95s/ambito/:ambito_id" component={F95s} />

          <Route exact path="/f95as" component={F95as} />
          <Route exact path="/f95as/ambito/:ambito_id" component={F95as} />

          <Route exact path="/f96s" component={F96s} />
          <Route exact path="/f96s/ambito/:ambito_id" component={F96s} />

          <Route exact path="/f97s" component={F97s} />
          <Route exact path="/f97s/ambito/:ambito_id" component={F97s} />

          <Route exact path="/f98s" component={F98s} />
          <Route exact path="/f98s/ambito/:ambito_id" component={F98s} />

          <Route exact path="/historiales" component={Historiales} />
          <Route exact path="/usuarios" component={Usuarios} />

          <Route exact path="/digital/f76s/ambito/:ambito_id" component={D76s} />

        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
